import Pagination from '@/util/pagination'

export default function () {
  return {
    templates: [],
    filters: {
      name: '',
    },
    pagination: new Pagination(),
  }
}
